module.exports = __webpack_public_path__ + "static/media/search-close.9c7bc016.svg";